const ADMIN_PORTAL_EMAILS = [
  "rchoudhary@preclinique.co.uk",
  "farqaankhan01@gmail.com",
  "ymaududi@preclinique.co.uk",
];

export function isAdminPortalEmail(email) {
  if (!email) return false;
  return ADMIN_PORTAL_EMAILS.includes(email.trim().toLowerCase());
}
